package com.yogaaicoach.pages.workout.data

import com.yogaaicoach.common.network.ApiClient
import com.yogaaicoach.pages.workout.data.models.CompleteWorkoutExerciseRequest
import com.yogaaicoach.pages.workout.data.models.MarkWorkoutExerciseHeavyRequest
import io.ktor.http.*

class WorkoutExerciseApi(private val client: ApiClient) {
    suspend fun completeWorkoutExercise(requestBody: CompleteWorkoutExerciseRequest): Unit? {
        return client.makeRequest(
            url = "${Config.API_URL}/completeWorkoutExercise",
            method = HttpMethod.Post,
            body = requestBody
        )
    }

    suspend fun markWorkoutExerciseHeavy(requestBody: MarkWorkoutExerciseHeavyRequest): Unit? {
        return client.makeRequest(
            url = "${Config.API_URL}/markWorkoutExerciseHeavy",
            method = HttpMethod.Post,
            body = requestBody
        )
    }
}